module.exports = __webpack_public_path__ + "9310d893fc81c374815227ce63494bb4.mov";